<!--维护人员列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">维护人员</span>
        <!-- <span class="describe">维护人员可在手机端登录服务平台，实时接收设备的故障通知、查看印量报表
          <a
          :href="guide"
          target="view_window"
          style="
            padding-left: 10px;
            font-size: 12px;
            font-weight: 600;
          "
          >使用步骤</a
        ></span> -->
      </div>
    </div>
    <div class="repair_tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size='20' color='#2d8cf0' style="margin-right:10px;" />
      <div>
        <div>维护人员需要激活后才能与设备绑定，在手机端登录服务平台，可实时接收设备的故障通知、查看设备状态、印量报表等，点击查看 <a :href="guide" target="view_window" style="
            padding-left: 10px;
            font-size: 12px;
            font-weight: 600;
          ">激活步骤和使用方法</a></div>
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <Input v-model="page.value" placeholder="根据条件搜索" @on-enter="getData(1)">
        <Select v-model="page.cond" slot="prepend" style="width: 80px">
          <Option value="repair.id">编号</Option>
          <Option value="repair.name">姓名</Option>
          <Option value="repair.tel">手机号</Option>
          <Option value="user_agent.name">所属</Option>
        </Select>
        <Button slot="append" icon="ios-search" @click="getData(1)"></Button>
        </Input>
        <Button style="margin: 2px 0 0 5px" @click="reset">重置</Button>
        <!-- <a
          :href="guide"
          target="view_window"
          style="
            padding-left: 10px;
            display: block;
            width: 118px;
            font-size: 14px;
            font-weight: 600;
          "
          >如何激活？</a
        > -->
      </div>
      <div class="right">
        <!-- <Select v-model="page.is_del" style="width: 100px; margin-right: 5px">
          <Option :value="0" style="text-align: center">维护人员</Option>
          <Option :value="1" style="text-align: center">禁用列表</Option>
        </Select> -->
        <Poptip title="导出Excel" placement="left" trigger="hover">
          <Button style="margin: 0 5px 1px 0">导出Excel</Button>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)">导出当前页</Button>
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
        <!-- <Button type="primary" style="margin-right: 5px" @click="change = true"
          >设备转移</Button
        > -->
        <Button type="primary" @click="perCreate">新增维护人员</Button>
      </div>
    </div>
    <Table :columns="columns" :data="data" :loading="tableLoading" @on-sort-change="tableSort" />
    <div class="t-right">
      <Page @on-change="pageChange" @on-page-size-change="sizeChange" :current="page.p + 1" :total="total" show-elevator
        show-sizer show-total />
    </div>
    <Modal :title="current.id ? '修改维护人员' : '新增维护人员'" v-model="visible" width="600">
      <div class="repair_tips" style="margin-bottom: 30px">
        <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right:10px;" />维护人员账号新增后，必须激活后才能与设备绑定
      </div>
      <Form ref="form" :model="current" :rules="rule" :label-width="100">
        <FormItem prop="name" label="姓名:">
          <Input v-model="current.name" style="width: 300px" placeholder="请输入姓名" />
        </FormItem>
        <FormItem prop="tel" label="账号:">
          <Input v-model="current.tel" placeholder="请输入手机号" style="width: 300px" />
        </FormItem>
        <FormItem label="权限:">
          <Select v-model="current.permission" style="width:200px" multiple>
            <Option value="report">印量</Option>
            <Option value="finance">收益</Option>
            <Option value="notification">平台公告</Option>
          </Select>
          <p style="font-size:12px;color:#888">未选择的权限，在公众号服务平台将无权查看</p>
        </FormItem>
        <FormItem prop="agent_id" label="合作伙伴:" v-if="!user.tp">
          <Select v-model="current.agent_id" style="width: 300px" filterable placeholder="默认自营">
            <!-- <Option :value="user.id">自营</Option> -->
            <Option v-for="(item, index) in agent" :key="index" :value="item.id">{{ item.agent_name }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="gender" label="性别:">
          <RadioGroup v-model="current.gender">
            <Radio :label="1">男</Radio>
            <Radio :label="0">女</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <!-- <div
        class="t-center"
        style="color: #ed4014; padding: 0 20px; text-align: left"
      >
        注: 手机号码是维护人员的账号，可在云知印公众号端登录服务后台
        &nbsp;（初始密码123456）
      </div> -->
      <div slot="footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" v-preventReClick :loading="loading" @click="save">确定</Button>
      </div>
    </Modal>

    <!-- <Modal title="设备转移" v-model="change">
      <Row>
        <Col span="9" offset="1">
          <Select
            v-model="changeSearch1"
            filterable
            remote
            :remote-method="getRemote1"
          >
            <Option
              v-for="(option, index) in changeData1"
              :value="option.id"
              :key="index"
              v-if="changeSearch2 ? option.id !== changeSearch2 : true"
              >{{ option.name }}</Option
            >
          </Select>
        </Col>
        <Col span="9" offset="4">
          <Select
            v-model="changeSearch2"
            filterable
            remote
            :remote-method="getRemote2"
          >
            <Option
              v-for="(option, index) in changeData2"
              :value="option.id"
              :key="index"
              v-if="changeSearch1 ? option.id !== changeSearch1 : true"
              >{{ option.name }}</Option
            >
          </Select>
        </Col>

        <Col
          span="9"
          offset="1"
          style="text-align: center; margin-top: 5px"
          v-if="machine1.length || machine2.length"
        >
          <Button size="small" type="info" @click="selectAll(1)">全选</Button>
        </Col>
        <Col
          span="4"
          style="text-align: center; margin-top: 5px"
          v-if="machine1.length || machine2.length"
        >
          <ButtonGroup type="button">
            <Button
              size="small"
              icon="md-arrow-round-back"
              type="info"
              @click="transfer(2, 1)"
            ></Button>
            <Button
              size="small"
              icon="md-arrow-round-forward"
              type="info"
              @click="transfer(1, 2)"
            ></Button>
          </ButtonGroup>
        </Col>
        <Col
          span="9"
          style="text-align: center; margin-top: 5px"
          v-if="machine1.length || machine2.length"
        >
          <Button size="small" type="info" @click="selectAll(2)">全选</Button>
        </Col>

        <Col span="24" style="margin-top: 5px"></Col>

        <Col span="9" offset="1" v-if="!machine1.length">&nbsp;</Col>
        <Col span="9" offset="1">
          <CheckboxGroup v-model="check1" v-if="machine1.length">
            <Checkbox
              style="width: 100%"
              v-for="(item, index) in machine1"
              :key="index"
              :label="item.id"
              :value="item.id"
            >
              <span>{{ item.sn }}</span>
            </Checkbox>
          </CheckboxGroup>
        </Col>

        <Col span="9" offset="1" v-if="!machine2.length">&nbsp;</Col>
        <Col span="9" offset="4">
          <CheckboxGroup v-model="check2" v-if="machine2.length">
            <Checkbox
              style="width: 100%"
              v-for="(item, index) in machine2"
              :key="index"
              :label="item.id"
              :value="item.id"
            >
              <span>{{ item.sn }}</span>
            </Checkbox>
          </CheckboxGroup>
        </Col>
      </Row>
      <div slot="footer">
        <Button @click="change = false">取消</Button>
        <Button type="primary" @click="transferMachine">确定</Button>
      </div>
    </Modal> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
import config from '../../../config/index'
export default {
  data () {
    return {
      guide: config.hostUser + '/wechat/meterreader/guide',
      change: false,
      changeSearch1: '',
      changeSearch2: '',
      changeData1: [],
      changeData2: [],
      machine1: [],
      machine2: [],
      check1: [],
      check2: [],

      data: [],
      tableLoading: false,
      total: 0,
      page: {
        cond: 'repair.id',
        value: '',
        // is_del: 0,
        p: 0,
        l: 10,
        key: 'repair.id',
        order: 'desc'
      },
      columns: [
        { title: '编号', width: 100, key: 'id', _sortKey: 'repair.id', sortable: 'custom' },
        {
          title: '姓名',
          key: 'name',
          sortable: 'custom',
          width: 200,
          // _sortKey: "repair.name",
          // sortable: "custom",

          render: (h, data) => {
            let arr = [
              h('TextTooltip', {
                style: {
                  width: '80px',
                  display: 'inline-block'
                },
                props: { val: data.row.name, len: 3 }
              })
            ]
            arr.push(
              h(
                'span',
                {
                  style: {
                    color: data.row.gzh_openid ? '#2D8cF0' : '#ff9900',
                    cursor: 'pointer'
                  },
                  on: {
                    click: () => {
                      console.log('点击了')
                      window.open(this.guide)
                    }
                  }
                },
                data.row.gzh_openid ? '正常' : '未激活'
              )
            )
            return arr
          }
        },
        {
          title: '账号',
          key: 'tel',
          _sortKey: 'repair.tel',
          sortable: 'custom'
        },
        {
          title: '性别',
          key: 'gender',
          // _sortKey: "repair.gender",
          // sortable: "custom",
          render: (h, data) => {
            return h('span', {}, data.row.gender ? '男' : '女')
          }
        },
        { title: '设备数', key: 'count' },
        {
          title: '合作伙伴',
          key: 'agent_name',
          _sortKey: 'user_agent.name',
          sortable: 'custom'
        },
        {
          title: '操作',
          width: 240,
          key: 'operator',
          render: (h, data) => {
            let arr = [
              h(
                'Button',
                {
                  props: {
                    size: 'small',
                    type: data.row.is_del ? 'success' : 'error'
                  },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: `是否${data.row.is_del ? '恢复' : '禁用'}`,
                        content: `是否${data.row.is_del ? '恢复' : '禁用'
                        }该维护人员`,
                        loading: this.confirmLoading,
                        onOk: () => {
                          this.confirmLoading = true
                          this.DelRenewRepair({
                            id: data.row.id,
                            is_del: data.row.is_del ? 0 : 1
                          }).then(() => {
                            this.confirmLoading = false
                            this.getData()
                          })
                        }
                      })
                    }
                  }
                },
                data.row.is_del ? '恢复' : '禁用'
              ),
              h(
                'Button',
                {
                  props: { size: 'small', type: 'info' },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '重置密码',
                        content: '是否重置该用户密码为:123456',
                        loading: this.confirmLoading,
                        onOk: () => {
                          this.confirmLoading = true
                          // this.current = data.row;
                          /*  this.current = data.row;
                          this.current.password = "123456";
                          this.save(); */

                          this.loading = true
                          let params = JSON.parse(JSON.stringify(data.row))
                          params.password = '123456'
                          delete params._index
                          delete params._rowKey
                          delete params.agent_name
                          delete params.count
                          if (!params.agent_id) {
                            delete params.agent_id
                          }
                          this.saveRepair(params).then((res) => {
                            this.loading = false
                            if (res.status) {
                              this.$Message.success('操作成功')
                              this.getData()
                            }
                          })

                          this.confirmLoading = false
                        }
                      })
                    }
                  }
                },
                '重置密码'
              ),
              h(
                'Button',
                {
                  props: { size: 'small', type: 'warning' },
                  on: {
                    click: () => {
                      let temp = JSON.parse(JSON.stringify(data.row))
                      this.perCreate(temp)
                    }
                  },
                  style: { marginRight: '5px' }
                },
                '修改'
              )
            ]
            /* if (!data.row.gzh_openid) {
              arr.push(
                h(
                  "Button",
                  {
                    props: { size: "small", type: "success" },
                    on: {
                      click: () => {
                        window.open(
                          config.hostUser + "/wechat/meterreader/guide"
                        );
                      },
                    },
                  },
                  "激活"
                )
              );
            } */
            return h('div', {}, arr)
          }
        }
      ],
      agent: [],
      visible: false,
      current: {
        gender: 1,
        permission: []
      },
      rule: {
        name: [{ required: true, message: '未输入姓名', trigger: 'blur' }],
        tel: [
          {
            required: true,
            type: 'number',
            trigger: 'blur',
            validator (rule, value, callback) {
              let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
              if (!reg.test(value)) {
                callback(new Error('请填写正确的手机号'))
              } else {
                callback()
              }
            }
          }
        ]
      },
      loading: false,
      confirmLoading: false
    }
  },
  methods: {
    reset () {
      this.page = {
        cond: 'repair.id',
        value: '',
        // is_del: 0,
        p: 0,
        l: 10,
        key: 'repair.id',
        order: 'desc'
      }
      this.getData()
    },
    transferMachine () {
      let temp = {}
      try {
        console.log(this.machine1, this.machine2)
        if (this.machine1.length) {
          temp[this.changeSearch1] = []
          this.machine1.map((item) => {
            temp[this.changeSearch1].push(item.id)
          })
        }
        if (this.machine2.length) {
          temp[this.changeSearch2] = []
          this.machine2.map((item) => {
            temp[this.changeSearch2].push(item.id)
          })
        }
        this.TransferMachine(temp).then((res) => {
          this.change = false
          this.$Message.success('转换成功')
        })
      } catch (error) {
        console.log(error)
      }
    },
    transfer (from, to) {
      if (this[`check${from}`].length) {
        this[`check${from}`].map((item, index) => {
          this[`machine${from}`].map((it, ind) => {
            if (item === it.id) {
              this[`machine${to}`].push(it)
              this[`machine${from}`].splice(ind, 1)
            }
          })
        })
        this[`check${from}`] = []
      } else {
        this.$Message.error('未选择设备')
      }
    },
    selectAll (type) {
      let temp = []
      this[`machine${type}`].map((item) => {
        temp.push(item.id)
      })
      if (this[`check${type}`].length === temp.length) {
        this[`check${type}`] = []
      } else {
        this[`check${type}`] = temp
      }
    },
    getRemote1 (text) {
      let cond = {
        text: text
      }
      if (this.changeSearch2) {
        this.changeData2.map((item) => {
          if (item.id === this.changeSearch2) {
            cond.agent_id = item.agent_id
          }
        })
      }
      this.SearchRepair(cond).then((res) => {
        this.changeData1 = res
      })
    },
    getRemote2 (text) {
      let cond = {
        text: text
      }
      if (this.changeSearch1) {
        this.changeData1.map((item) => {
          if (item.id === this.changeSearch1) {
            cond.agent_id = item.agent_id
          }
        })
      }
      this.SearchRepair(cond).then((res) => {
        this.changeData2 = res
      })
    },
    // 导出excel 是否导出全部
    exportData (is_all) {
      let params = {
        title: ['编号', '姓名', '账号', '性别', '设备数', '合作伙伴'],
        key: ['id', 'name', 'tel', 'gender', 'count', 'agent_name'],
        autoWidth: true,
        filename: '维护人员列表'
      }
      if (is_all) {
        let page = JSON.parse(JSON.stringify(this.page))
        page.l = this.total
        page.p = 0
        this.getRepair(page).then((res) => {
          res.data.map((item) => {
            item.gender = item.gender ? '男' : '女'
            item.name = item.name + `(${item.gzh_openid ? '正常' : '未激活'})`
          })
          params.data = res.data
          excel.export_array_to_excel(params)
        })
      } else {
        let temp = JSON.parse(JSON.stringify(this.data))
        temp.map((item) => {
          item.gender = item.gender ? '男' : '女'
          item.name = item.name + `(${item.gzh_openid ? '正常' : '未激活'})`
        })
        params.data = temp

        excel.export_array_to_excel(params)
      }
    },
    tableSort (col) {
      this.page.key = col.column._sortKey
      this.page.order = col.order
      this.getData()
    },
    perCreate (data) {
      data.permission = data.permission ? data.permission.split(',') : []
      this.current = data.gender >= 0 ? data : { gender: 1, permission: [] }
      this.visible = true
      this.$refs.form.resetFields()// 重置表单验证

      if (!this.current.agent_id) {
        this.current.agent_id = this.user.id
      }
      if (!this.user.tp && !this.agent.length) {
        this.getAgentList({ p: 0, l: 1000, is_del: 0 }).then((res) => {
          this.agent = res.data
        })
      }
    },
    getData (filter) {
      if (filter) {
        this.page.p = 0
      }
      this.tableLoading = true
      this.getRepair(this.page).then((res) => {
        this.total = res.total
        this.data = res.data
        this.tableLoading = false
      })
    },
    save () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          let data = JSON.parse(JSON.stringify(this.current))
          data.permission = data.permission.join(',')
          delete data._index
          delete data._rowKey
          delete data.agent_name
          delete data.count
          if (!data.agent_id) {
            delete data.agent_id
          }
          this.saveRepair(data).then((res) => {
            this.loading = false
            if (res.status) {
              this.visible = false
              if (res.id) {
                this.current.id = res
              }
              this.$Message.success('操作成功')
              this.getData()
            } else {
              this.$Message.error('该用户已存在')
            }
          })
        }
      })
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    ...mapActions([
      'getRepair',
      'saveRepair',
      'getAgentList',
      'SearchRepair',
      'GetRepairMachine',
      'TransferMachine',
      'DelRenewRepair'
    ])
  },
  mounted () {
    this.getData()
  },
  computed: mapGetters({
    user: 'agent'
  }),
  watch: {
    'page.is_del' (n, o) {
      this.getData()
    },
    changeSearch1 (n, o) {
      if (n) {
        let cond = { id: n }
        if (this.user.tp) {
          cond.agent_id = this.user.id
        }
        this.GetRepairMachine(cond).then((res) => {
          this.machine1 = res.length ? res : []
        })
      }
    },
    changeSearch2 (n, o) {
      if (n) {
        let cond = { id: n }
        if (this.user.tp) {
          cond.agent_id = this.user.id
        }
        this.GetRepairMachine(cond).then((res) => {
          this.machine2 = res.length ? res : []
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
